export var datepickerCalendarGridStyles = {
  root: function root() {
    return {
      'border-spacing': '0rem',
      tableLayout: 'fixed'
    };
  }
};